exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2SiDFhjUSfZR8Z4wY49kR7{font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;font-size:14px}._1N1TeHqt_DE4tNfLeyK_Ej{margin-bottom:10px}._10OtkqtAAtqsnO9OXRu4DU{font-family:\"futura-pt\",\"Futura PT\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;margin:30px 0 0 0}._10OtkqtAAtqsnO9OXRu4DU a{color:inherit;text-decoration:none}._2hT7CWz4_CUnZrhzDanvYO{margin:10px 0}a.ZVwJUAbihd4MBpfYOEFYi,a._1JbLOB8Evtg2DEDutFhjyG,a.SkuwT7kMCbD7XcBooTU2e{color:#666;text-decoration:none;cursor:pointer}a._2Xu_JIkF8ts8h5m_juhPxL{color:#b71c1c;text-decoration:none;cursor:pointer}._1NcDALb25QWS1mX_Dax4fb{margin:30px 0}._3-TOUTxjhCZh9xRed0FFYN{font-style:italic;margin:20px 0;color:#666}\n", ""]);

// Exports
exports.locals = {
	"DraftList": "_2SiDFhjUSfZR8Z4wY49kR7",
	"pageTitleOverride": "_1N1TeHqt_DE4tNfLeyK_Ej",
	"draftTitle": "_10OtkqtAAtqsnO9OXRu4DU",
	"draftMeta": "_2hT7CWz4_CUnZrhzDanvYO",
	"viewLink": "ZVwJUAbihd4MBpfYOEFYi",
	"editLink": "_1JbLOB8Evtg2DEDutFhjyG",
	"restoreLink": "SkuwT7kMCbD7XcBooTU2e",
	"deleteLink": "_2Xu_JIkF8ts8h5m_juhPxL",
	"spinner": "_1NcDALb25QWS1mX_Dax4fb",
	"hint": "_3-TOUTxjhCZh9xRed0FFYN"
};